export default __webpack_public_path__ + "static/media/banner-2.e678d489.jpeg";